import { IPlaceAddress } from 'utils/geolocation';

export const formatAddressLine1 = (
  addressComponents: Partial<IPlaceAddress>,
  isStreetNameFirst: boolean
) => {
  if (addressComponents.route) {
    const addressWithRoute = isStreetNameFirst
      ? `${addressComponents.route} ${addressComponents.streetNumber}`
      : `${addressComponents.streetNumber} ${addressComponents.route}`;
    return addressWithRoute;
  }
  const addressWithAddresLine1 = isStreetNameFirst
    ? `${addressComponents.addressLine1} ${addressComponents.streetNumber}`
    : `${addressComponents.streetNumber} ${addressComponents.addressLine1}`;
  return addressWithAddresLine1;
};

export const getSplitAddressTitle = (
  addressComponents: IPlaceAddress | null,
  isStreetNameFirst: boolean
) => {
  if (!addressComponents?.route && !addressComponents?.addressLine1) {
    return;
  }

  return formatAddressLine1(addressComponents, isStreetNameFirst);
};

export const getAddressSubtitle = (addressComponents: IPlaceAddress | null): string => {
  return [addressComponents?.city, addressComponents?.zip, addressComponents?.country]
    .filter(Boolean)
    .join(', ');
};
